module.exports = __webpack_public_path__ + "static/media/svg-goutte-vide.b4f85a05.svg";